import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'skip',
    standalone: true
})
export class SkipPipe implements PipeTransform {

   transform(values: {}[], skip: number) {
    return values.slice(skip);
  }

}
